<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <div class="formRow">
            <h4>Template name*:</h4>
            <input type="text" v-model="$parent.mediaProperty.configuration.templateName" @change="saveEmailTemplate" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>Open Modal Text:</h4>
            <input type="text" placeholder="Send Results As Email" v-model="openModalText" @change="saveEmailTemplate" :disabled="!$parent.mediaProperty.isActive"/>
            <TranslatedText v-if="$parent.mediaProperty.configuration.openModalTextJson && $parent.mediaProperty.configuration.openModalTextJson.length > 1"
                                :textJson="$parent.mediaProperty.configuration.openModalTextJson"
                                position="bottom" alignment="start" :defaultLanguage="$parent.mediaProperty.defaultLanguage"></TranslatedText>
        </div>
        <div class="formRow">
            <h4>Email Logo:</h4>
            <span v-if="emailLogoMediaProperty" class="mpDescription">{{ emailLogoMediaProperty.description }}</span>
            <button @click="showEmailLogoModal()" class="openModalButton" :disabled="!$parent.mediaProperty.isActive">
                <i v-if="!emailLogoMediaProperty" class="fa-circle-plus fas fa-2xl"></i>
                <i v-if="emailLogoMediaProperty" class="fa-pen-to-square fas fa-2xl"></i>
            </button>
            <button v-if="emailLogoMediaProperty" @click="removeEmailLogo()" class="removeMediaPropertyButton" :disabled="!$parent.mediaProperty.isActive">
                <i class="fa-trash-can fas fa-lg"></i>
            </button>
            <AddMediaPropertyModal v-if="showImageModal" mediaTypeFilter="Image"
                                :object="$parent.mediaProperty.configuration"
                                @saveMediaProperty="saveEmailLogo"
                                :isActive="$parent.mediaProperty.isActive"
                                @hideAddMediaPropertyModal="hideEmailLogoModal()"></AddMediaPropertyModal>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import AddMediaPropertyModal from '@/components/mediaproperty/AddMediaPropertyModal.vue';
import {translation} from '../../shared/translation';
import TranslatedText from '@/components/shared/TranslatedText.vue';

export default {
    name: 'EmailTemplateEdit',
    components: { AddMediaPropertyModal, TranslatedText },
    data: function() {
        return {
            showImageModal: false,
            emailLogoMediaProperty: null
        }
    },
    computed: {
        validated() {
            let configuration = this.$parent.mediaProperty.configuration;
            return (
                configuration.templateName &&
                configuration.templateName.length > 0
            )
        },
        displayText() {
            return translation.getTranslatedText(this.$parent.mediaProperty.defaultLanguage, this.$parent.mediaProperty.configuration.openModalTextJson);
        },
        openModalText: {
            get() {
                return translation.getTextForLanguage(this.$parent?.mediaProperty?.configuration?.openModalTextJson, this.$parent.mediaProperty.defaultLanguage);
            },
            set(newText) {
                translation.setTextForLanguage(this.$parent.mediaProperty.configuration, this.$parent.mediaProperty.defaultLanguage, 'openModalTextJson', newText);
            }
        }
    },
    async mounted() {
        if(!this.$parent.mediaProperty.configuration) {
            this.$parent.mediaProperty.configuration = {
                templateName: '',
                logoImageMediaPropertyId: 0,
                openModalTextJson: []
            }
        }
        if(this.$parent.mediaProperty.configuration.logoImageMediaPropertyId > 0)
            this.emailLogoMediaProperty = await data.getMediaProperty(this.$parent.mediaProperty.configuration.logoImageMediaPropertyId);
    },
    methods: {
        saveEmailTemplate: async function() {
            if(this.validated) {
                this.$parent.mediaProperty.configuration.openModalTextJson = await translation.addTranslations(this.$parent.mediaProperty.configuration.openModalTextJson, this.openModalText, this.$parent.mediaProperty.languages, this.$parent.mediaProperty.defaultLanguage);
                const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
                if(!this.$parent.mediaProperty.id && resp.id) {
                    this.$parent.mediaProperty.id = resp.id;
                    this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
                }
            }
            else
                this.$toast.error('Template Name is required');
        },
        saveEmailLogo: async function(emailTemp, image) {
            emailTemp.logoImageMediaPropertyId = image.id;
            await this.saveEmailTemplate();
            this.emailLogoMediaProperty = await data.getMediaProperty(image.id);
        },
        removeEmailLogo: async function() {
            this.$parent.mediaProperty.configuration.logoImageMediaPropertyId = 0;
            this.emailLogoMediaProperty = null;
            this.processDeleteResult(await data.saveMediaProperty(this.$parent.mediaProperty));
        },
        showEmailLogoModal: function() {
            this.showImageModal = true;
        },
        hideEmailLogoModal: function() {
            this.showImageModal = false;
        },
        addLanguage: async function(lang) {
            await translation.addTranslationToField(this.$parent.mediaProperty.configuration.openModalTextJson, lang, this.$parent.mediaProperty.defaultLanguage);

            await this.saveEmailTemplate();
        },
        deleteLanguage: async function(lang) {
            translation.removeLanguageFromField(this.$parent.mediaProperty.configuration.openModalTextJson, lang);

            await this.saveEmailTemplate();
        }
    }
}
</script>

<style scoped>
    .openModalButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 12px;
        color:#036991;
    }
    .editFieldButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        color:#036991;
        margin-left: 10px;
    }
    .removeMediaPropertyButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 12px;
        color:darkred;
    }
    .mpDescription {
        margin-right: 10px;
    }
</style>